import { useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { Flex, MainHeadline, PageWrapper, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import {
  kitchenCookable,
  kitchenCostPerPortion,
  kitchenDishesMock,
  kitchenExpiryScore,
  kitchenIngredientsMock,
  kitchenSitesMock,
} from './kitchenData'
import { IKitchenDish } from 'types/kitchen/kitchenDish.interface'
import { DashboardTab } from './tabs/DashboardTab'
import { MenuPlannerTab } from './tabs/MenuPlannerTab'
import { DishesTab } from './tabs/DishesTab'
import { IngredientsTab } from './tabs/IngredientsTab'
import { ProductionTab } from './tabs/ProductionTab'
import { SuggestionsTab } from './tabs/SuggestionsTab'

const KITCHEN_TABS = ['Dashboard', 'Menu Planner', 'Dishes', 'Ingredients', 'Production', 'Suggestions']

export const Kitchen = () => {
  const [activeTab, setActiveTab] = useState('Dashboard')
  const [ingredients] = useState(kitchenIngredientsMock)
  const [dishes] = useState<IKitchenDish[]>(kitchenDishesMock)
  const [kitchens] = useState(kitchenSitesMock)
  const [createDishOpen, setCreateDishOpen] = useState(false)
  const [menuPlannerToolbar, setMenuPlannerToolbar] = useState<React.ReactNode>(null)

  const costPerPortion = (dish: IKitchenDish) => kitchenCostPerPortion(dish, ingredients)
  const cookable = (dish: IKitchenDish) => kitchenCookable(dish, ingredients)
  const expiryScore = (dish: IKitchenDish) => kitchenExpiryScore(dish, ingredients)

  const handleTabChange = (tab: string) => {
    setActiveTab(tab)
    if (tab !== 'Menu Planner') setMenuPlannerToolbar(null)
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <MainHeadline>Kitchen</MainHeadline>
        </Flex>
        <Flex between alignEnd mb='16' width='100%' wrap gap='1rem'>
          <TabsContainer>
            {KITCHEN_TABS.map((tab) => (
              <Tabs key={tab} active={activeTab === tab} onClick={() => handleTabChange(tab)}>
                {tab}
              </Tabs>
            ))}
          </TabsContainer>
          {activeTab === 'Menu Planner' && menuPlannerToolbar}
          {activeTab === 'Dishes' && (
            <Button variant='primary' onClick={() => setCreateDishOpen(true)}>
              New Dish
            </Button>
          )}
        </Flex>
        {activeTab === 'Dashboard' && (
          <DashboardTab
            ingredients={ingredients}
            dishes={dishes}
            kitchens={kitchens}
            costPerPortion={costPerPortion}
          />
        )}
        {activeTab === 'Menu Planner' && (
          <MenuPlannerTab
            kitchens={kitchens}
            dishes={dishes}
            cookable={cookable}
            onToolbarChange={setMenuPlannerToolbar}
          />
        )}
        {activeTab === 'Dishes' && (
          <DishesTab createOpen={createDishOpen} setCreateOpen={setCreateDishOpen} />
        )}
        {activeTab === 'Ingredients' && <IngredientsTab />}
        {activeTab === 'Production' && <ProductionTab kitchens={kitchens} />}
        {activeTab === 'Suggestions' && (
          <SuggestionsTab
            dishes={dishes}
            cookable={cookable}
            expiryScore={expiryScore}
            costPerPortion={costPerPortion}
          />
        )}
      </PageWrapper>
    </>
  )
}
